var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVectorCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.227072 0.227051C0.519965 -0.0658413 0.994839 -0.0658414 1.28773 0.227051L6.00004 4.93934L10.7124 0.227051C11.0052 -0.065841 11.4801 -0.065841 11.773 0.227051C12.0659 0.519943 12.0659 0.994816 11.773 1.28771L7.0607 6L11.773 10.7123C12.0659 11.0052 12.0659 11.4801 11.773 11.7729C11.4801 12.0658 11.0052 12.0658 10.7124 11.7729L6.00004 7.06066L1.28773 11.7729C0.994839 12.0658 0.519965 12.0658 0.227072 11.7729C-0.0658213 11.4801 -0.0658213 11.0052 0.227072 10.7123L4.93938 6L0.227072 1.28771C-0.0658213 0.994815 -0.0658213 0.519943 0.227072 0.227051Z",
    fill: "#FAF7E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorCross);
export default __webpack_public_path__ + "static/media/vector_cross.2806550ffb9483815136d0f80d7a5e9d.svg";
export { ForwardRef as ReactComponent };